module.exports = __webpack_public_path__ + "img/Slider.a61acde.png";